<div class="advise-banner-container">
    <img src="../../../assets/images/security key.png" width="102,6px"/>
    <div class="advise-banner-paragraph">
        <span class="bold">{{'Ahora conectaremos de forma segura con los bancos seleccionados' | translate}}</span>
        <span>{{'A continuación, verás la ventana de acceso a cada uno de ellos para que te identifiques.' | translate}}</span>
        <span>{{'La otra entidad solo nos mandará los movimientos de los últimos meses de tus cuentas una única vez.' | translate}}</span>
    </div>
    <button class="primary" (click)="continue()">
        <span>{{'Continuar de manera segura' | translate}}</span>
    </button>
</div>
<app-ag-button-set
  [primaryShow]="false"
  [tertiaryLabel]="'Cancelar'"
  (backButton)="back()"
  (cancelButton)="cancel()"
></app-ag-button-set>
